import React from 'react';
import { Link } from "react-router-dom";
 
const Updated = (props) => {
    return (
       <div className={props.Color}>
          <p>{props.Message}</p>
       </div>
    );
}
 
export default Updated;